import { IToolPanelAngularComp } from '@ag-grid-community/angular';
import { IToolPanelParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { GridComponent } from '../../grid.component';

@Component({
    selector: 'tt-settings-tool-panel',
    templateUrl: './settings-tool-panel.component.html',
    styleUrls: ['./settings-tool-panel.component.css'],
})
export class SettingsToolPanelComponent implements IToolPanelAngularComp {
    headerTextWrapping = false;

    rowTextWrapping = false;

    params!: IToolPanelParams & { grid: GridComponent };

    public toggleHeaderTextWrapping() {
        this.params.grid.updateDefaultColumnDefinition({ wrapHeaderText: this.headerTextWrapping });
        this.params.grid.rememberGridState$.next(null);
    }

    public toggleRowTextWrapping() {
        this.params.grid.updateDefaultColumnDefinition({ wrapText: this.rowTextWrapping });
        this.params.grid.rememberGridState$.next(null);
    }

    refresh(params: IToolPanelParams<any, any, any>): boolean | void {}

    agInit(params: IToolPanelParams<any, any, any> & { grid: GridComponent }): void {
        this.params = params;
        this.headerTextWrapping = this.params.grid.defaultColumnDefinitions.wrapHeaderText ?? false;
        this.rowTextWrapping = this.params.grid.defaultColumnDefinitions.wrapText ?? false;
    }
}
